export const resourcePaths = {
  ASSET_REVIEW_ASSET: '/asset-review/asset',
  ASSET2_REVIEW_ASSET: '/ads-asset2-reviewer-ui/asset',
};
